export default "__VITE_ASSET__D6BH0N7e__"